var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-avatar',{attrs:{"color":_vm.computedColor,"size":_vm.size}},[_vm._v(" "+_vm._s(_vm.computedInitial)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }